import { render } from "./GuardingWorkingShiftContent.vue?vue&type=template&id=6c203b20"
import script from "./GuardingWorkingShiftContent.vue?vue&type=script&lang=js"
export * from "./GuardingWorkingShiftContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__